import { createLucideIcon } from "lucide-react";

export const CircleCheckFilled = createLucideIcon("CircleCheckFilled", [
    ["circle", { cx: "12", cy: "12", r: "10", fill: "currentColor", stroke: "none" }],
    ["path", { d: "M9 12l2 2l4-4", stroke: "white", fill: "none" }]
]);
